<div class="os-container">
    <div class="os-picture">
        <img src="{{ location }}"
             alt="{{ title }}"
             [width]="size"
             [height]="size"
             loading="lazy"
             [ngClass]="{'demi': size === 24,'two-thirds': size === 36}"
             />
    </div>
</div>
